<app-admin-dashboard>
  <p-card header="Actualización masiva de programas">
    <app-program-massive-import-table
        [loading]="loading">
    </app-program-massive-import-table>
    <p>
      Actualización masiva de información de programas
    </p>
    <form [formGroup]="form">
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-6">
          <label for="exporterUsername" style="font-weight: bolder"
            >Exporter *</label
          >
          <p-dropdown
            id="exporterUsername"
            formControlName="exporterUsername"
            [options]="exporters"
            optionValue="contactEmail"
            optionLabel="companyName"
            [filter]="true"
            filterBy="companyName"
            [showClear]="false"
            (onChange)="onChangeExporter()"
            placeholder="Exporter"
          >
          </p-dropdown>
        </div>
      </div>
    </form>

    <div class="p-fluid formgrid mr-2 ml-2 grid">
      <div class="field col-3">
        <label class="font-bold">Año inicial *</label>
        <p-dropdown
          [options]="years"
          [(ngModel)]="startYear"
          placeholder="Año"
          [showClear]="true"
          (onChange)="onStartYearChange($event.value)"
        >
        </p-dropdown>
      </div>

      <div class="field col-3">
        <label class="font-bold">Año final *</label>
        <p-dropdown
          [options]="endYearOptions"
          (onChange)="onEndYearChange($event.value)"
          [(ngModel)]="endYear"
          placeholder="Año"
          [showClear]="true"
          [disabled]="!startYear"

        >
        </p-dropdown>
      </div>
    </div>
    <div class="p-fluid formgrid mr-2 ml-2 grid">
      <div class="col-3">
        <p-button
          type="button"
          pRipple
          pTooltip="Excel"
          (click)="downloadProgramsExcel()"
          [loading]="loadingBtnDownload"
          [disabled]="!enableExportProgramsButton"
          tooltipPosition="bottom"
          [style]="{ width: 'fit-content' }"
        >
          {{ "UserPages.PackingListView.ExportExcel" | translate }}
        </p-button>
      </div>
    </div>

    <div class="col-6">
      <h3>Seleccionar archivo Excel</h3>
      <p-fileUpload
        name="sheetPdf[]"
        #imagesUploader
        (onSelect)="onSelect($event, imagesUploader)"
        (onRemove)="onRemove($event, imagesUploader)"
        (onClear)="onClear($event, imagesUploader)"
        [showUploadButton]="false"
        [multiple]="false"
        accept=".xlsx"
        [fileLimit]="1"
        [files]="uploadFile"
        [maxFileSize]="3000000"
        chooseLabel="Seleccionar"
      >
        <ng-template pTemplate="toolbar"> </ng-template>
        <ng-template pTemplate="content"> </ng-template>
      </p-fileUpload>
      <div class="col-12 flex justify-content-end">
        <p-button
          label="Cargar"
          (onClick)="sendFiles()"
          [loading]="loading"
          [disabled]="uploadDisabled && !enableUploadProgramButton"
        ></p-button>
      </div>
    </div>
  </p-card>
</app-admin-dashboard>
